module.exports = __webpack_public_path__ + "img/aboutuspic1.27f097bb.jpg";